import { ReactNode } from 'react';

type DataContainerPropsType = {
    children: ReactNode;
    className?: string;
};
function CellDataContainer({ children, className = '' }: DataContainerPropsType) {
    return <div className={`flex flex-align-center ${className}`}>{children}</div>;
}

export default CellDataContainer;
